import React from 'react';
import toast from 'react-hot-toast';
import { Trash2 } from 'lucide-react';

import AssignmentService, { AssignmentData } from '@/services/course/assignment-service';
import ConfirmationModal from '@/common/components/modals/general/ConfirmationModal';
import { CourseId } from 'course-types';

interface DeleteSubmissionModalProps {
  assignment: AssignmentData;
  onDeleteSuccess: () => void;
  courseId: CourseId;
  email?: string;
}

function DeleteSubmissionModal({
  assignment,
  onDeleteSuccess,
  courseId,
  email,
}: DeleteSubmissionModalProps) {
  const handleDeleteSubmission = async () => {
    try {
      const result = await AssignmentService.deleteSubmission(assignment, courseId, email);

      if (!result.success) {
        throw new Error('Failed to delete submission');
      }

      onDeleteSuccess();
    } catch (error) {
      console.error('Error deleting submission:', error);
      toast.error(error instanceof Error ? error.message : 'Failed to delete submission');
      throw error;
    }
  };

  return (
    <ConfirmationModal
      modalName='DeleteSubmission'
      title={`Delete Submission for "${assignment.name}"`}
      subtitle='This action cannot be undone'
      message='Are you sure you want to delete your submission?'
      description='This will permanently remove your submitted file and cannot be recovered. You will be able to submit a new file after deletion.'
      confirmText='Delete Submission'
      confirmIcon={<Trash2 className='w-5 h-5' />}
      isDestructive={true}
      onConfirm={handleDeleteSubmission}
    />
  );
}

export default DeleteSubmissionModal;
